import { useState, type FormEvent } from 'react';
import { Alert, Button, Paper, TextField } from '@mui/material';
import { Stack, Typography } from '../components/mui-system';
import { api } from '../api/client';
export function AlertsPreview({ workspace, editable }: { workspace: string; editable: boolean }) {
  const [sender, setSender] = useState('');
  const [subject, setSubject] = useState('');
  const [text, setText] = useState('');
  const [result, setResult] = useState<Awaited<ReturnType<typeof api.previewAlert>> | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      <Stack
        gap={2}
        component="form"
        onSubmit={(e: FormEvent) => {
          e.preventDefault();
          setBusy(true);
          setError('');
          setResult(null);
          void api
            .previewAlert(workspace, {
              mailbox: 'preview',
              messageId: 'preview',
              sender,
              subject,
              text,
              receivedAt: new Date().toISOString(),
            })
            .then(setResult)
            .catch((e) => setError(e instanceof Error ? e.message : 'Ошибка'))
            .finally(() => setBusy(false));
        }}
      >
        <Typography variant="h6">Проверка по сохранённому AI-промпту</Typography>
        <Typography color="text.secondary">
          Письмо не сохраняется в журнале и не отправляется в Telegram. Сначала сохраните изменения
          модели и промпта. Проверка использует OpenAI и расходует токены.
        </Typography>
        <TextField
          required
          disabled={!editable || busy}
          type="email"
          label="Email отправителя"
          value={sender}
          onChange={(e) => setSender(e.target.value)}
        />
        <TextField
          required
          disabled={!editable || busy}
          label="Тема письма"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        />
        <TextField
          required
          disabled={!editable || busy}
          multiline
          minRows={8}
          label="Текст письма"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <Button type="submit" disabled={!editable || busy} variant="contained">
          Проверить без отправки
        </Button>
        {error && <Alert severity="error">{error}</Alert>}
        {result && (
          <Alert severity={result.action === 'review' ? 'warning' : 'info'}>
            {result.action === 'notify'
              ? 'Подходит для отправки'
              : result.action === 'ignore'
                ? 'Без отправки'
                : 'Требует разбора'}
            : {result.reason}
            <br />
            Сайт: {result.site ?? 'не определён'} · настройки v{result.revision}
            {!result.deliveryEnabled && ' · доставка выключена'}
            {result.analysis && (
              <>
                <br />
                Модель: {result.analysis.model}
              </>
            )}
            {result.analysis?.result && (
              <>
                <br />
                Категория: {result.analysis.result.category ?? 'не определена'}
                <br />
                Приоритет: {result.analysis.result.priority ?? 'не определён'}
                <br />
                {result.analysis.result.summary}
                <br />
                Требует действий:{' '}
                {result.analysis.result.action_required === null
                  ? 'не определено'
                  : result.analysis.result.action_required
                    ? 'да'
                    : 'нет'}
              </>
            )}
          </Alert>
        )}
      </Stack>
    </Paper>
  );
}
